import React from 'react';
import { Button, Spinner } from '@ems/client-design-system';

/**
 * A component that displays a load more button with loading spinner.
 *
 * @component
 * @param {Object} props - The component props
 * @param {boolean} props.isLoading - Indicates if content is currently loading
 * @param {Function} props.onClick - Function to call when the button is clicked
 * @param {React.ReactNode} [props.children] - Optional content to display inside the button. Defaults to 'Load More'
 * @param {boolean} [props.disabled] - Optional flag to disable the button
 * @returns {JSX.Element} A button with loading spinner that allows users to load more content
 */
export const LoadMoreBar: React.FC<{
  isLoading: boolean;
  onClick: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
}> = ({ isLoading, onClick, children, disabled }) => (
  <div className="load-more-bar">
    <Spinner loading={isLoading}>
      <Button style="primary" onClick={onClick} disabled={disabled}>
        {children || 'Load More'}
      </Button>
    </Spinner>
  </div>
);
